document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  const selected = event.target.options[event.target.selectedIndex];
  const priceEl = document.querySelector('[data-product-price]');
  const button = document.querySelector('[data-add-button]');
  if (priceEl && selected.dataset.price) priceEl.textContent = selected.dataset.price;
  if (button) {
    const available = selected.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? 'Agregar al carrito' : 'Agotado';
  }
});

// Product gallery: thumbnails + previous/next controls.
document.addEventListener('click', function (event) {
  const gallery = event.target.closest('[data-product-gallery]');
  if (!gallery) return;

  const mainImage = gallery.querySelector('[data-gallery-main-image]');
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  if (!mainImage || !thumbs.length) return;

  function activate(index) {
    const safeIndex = (index + thumbs.length) % thumbs.length;
    const thumb = thumbs[safeIndex];
    mainImage.src = thumb.dataset.gallerySrc;
    mainImage.alt = thumb.dataset.galleryAlt || '';
    thumbs.forEach(function (item, i) {
      const active = i === safeIndex;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    activate(Number(thumb.dataset.galleryIndex || 0));
    return;
  }

  const activeIndex = Math.max(0, thumbs.findIndex(function (item) {
    return item.classList.contains('is-active');
  }));

  if (event.target.closest('[data-gallery-prev]')) activate(activeIndex - 1);
  if (event.target.closest('[data-gallery-next]')) activate(activeIndex + 1);
});
